import React from 'react';
import {RoleLayout} from '../roles/RoleShell';
import PanelRolConfigurable from '../roles/PanelRolConfigurable';
import {normalizarPoliticaRol} from '../../utils/permisosRol';
export default function Barra(){return <RoleLayout title="Barra" roleLabel="Barra"><PanelRolConfigurable profile={{rol:'barra',politicaRol:normalizarPoliticaRol('barra')}}/></RoleLayout>;}
